<div class="row tabs-arrow">
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'restaurant.Branches' | translate}}</p>
                </div>
                <div class="col-3">
                    <a class="arrow-back" [routerLink]="['/admin/restaurants']" [queryParams]="{ isProfile, restaurantId }">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'stockManagement.Suppliers' | translate}}</p>
                </div>
                <div class="col-3">
                    <a class="arrow-back" [routerLink]="['/admin/stockConfig/suppliers', restaurantId]" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'stockManagement.Stock Transactions' | translate}}</p>
                </div>
                <div class="col-3">
                    <a class="arrow-back" [routerLink]="['/admin/stockConfig/stockTransaction']" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'restaurant.Modifiers' | translate}}</p>
                </div>
                <div class="col-3">
                    <a [routerLink]="['/admin/menu-management/modifiers']" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)" class="arrow-back">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'restaurant.Menu Items Categories' | translate}}</p>
                </div>
                <div class="col-3">
                    <a [routerLink]="['/admin/menu-management/menu-categories']" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)" class="arrow-back">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'restaurant.Ingredients Units Config' | translate}}</p>
                </div>
                <div class="col-3">
                    <a [routerLink]="['/admin/stockConfig/Ingredients']" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)" class="arrow-back">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'content3.Menu Items' | translate}}</p>
                </div>
                <div class="col-3">
                    <a [routerLink]="['/admin/menu-management/menu-items']" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)" class="arrow-back">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'restaurant.Menus' | translate}}</p>
                </div>
                <div class="col-3">
                    <a class="arrow-back" [routerLink]="['/admin/menu-management/menus']" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3">
        <div class="card">
            <div class="row no-gutters">
                <div class="col-9">
                    <p class="font-20 text-left fontMedium pl-3">{{'sizes.Sizes Config' | translate}}</p>
                </div>
                <div class="col-3">
                    <a class="arrow-back" [routerLink]="['/admin/menu-management/sizes']" [queryParams]="{ isProfile }" (click)="navigateToSideBar(restaurantId)">
                        <mat-icon class="card-img">keyboard_arrow_right</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
